module.exports = __webpack_public_path__ + "static/media/samplecheque.c3f8f6c1.png";